// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("./IconV5.bs.js");
let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");

function Alert$Success(props) {
  let __className = props.className;
  let className = __className !== undefined ? __className : "";
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(IconV5.make, {
              icon: "ok-circled"
            }),
            className: "w-4 h-4 text-green-400"
          }),
          className: "flex-shrink-0"
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx("p", {
            children: props.title,
            className: "font-medium text-green-800"
          }),
          className: "ml-3"
        })
      ],
      className: "flex"
    }),
    className: TailwindMerge.twMerge([
      "rounded-md bg-green-50 p-4",
      className
    ])
  });
}

let Success = {
  make: Alert$Success
};

function Alert$Error(props) {
  let __className = props.className;
  let className = __className !== undefined ? __className : "";
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(IconV5.make, {
              icon: "cancel-circled"
            }),
            className: "w-4 h-4 text-red-400"
          }),
          className: "flex-shrink-0"
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx("p", {
            children: props.title,
            className: "font-medium text-red-700"
          }),
          className: "ml-3"
        })
      ],
      className: "flex"
    }),
    className: TailwindMerge.twMerge([
      "rounded-md bg-red-50 p-4",
      className
    ])
  });
}

let $$Error = {
  make: Alert$Error
};

exports.Success = Success;
exports.$$Error = $$Error;
/* IconV5 Not a pure module */
